<template>
  <div id="app">
    <div class="mobile-msg position-fixed d-md-none d-block text-white h-100 w-100 text-center bg-primary pt-5">
      <div class="logo-holder">
        <img src="@/assets/logo.png"></div>
        <h2 class="py-5">
          <span class="hebrew-message">הכלי לניתוח מורפולוגי אינו זמין בנייד</span>
        </h2>
    </div>       
    <header>
      <dicta-header :englishSupported="true"></dicta-header>
      <div class="bg-primary second-header d-flex">
        <div class="container">
          <div class="row">
            <div class="col-sm-6">
              <div class="logo-div">  
                <div class="logo"  @click="resetData">
                  <img src="@/assets/logo.png" alt="logo"/>
                </div>{{hebrew ? 'ניתוח מורפולוגי' : 'Morphology Analysis'}}
              </div>            
            </div>
            <div 
              class="col-6" 
              :class="{'text-left': hebrew, 'text-right' : !hebrew}">
              <b-button id="getInstructionsBttn" variant="primary" class="btn-outline-light" size="md" @click="showAbout = true">
                {{hebrew ? 'איך זה עובד' : 'How it works'}}
              </b-button>
            </div>  
          </div>
        </div>
      </div>
    </header>  
    <router-view></router-view>
    <about-dialog v-model="showAbout"></about-dialog>
  </div>
</template>

<script>

import AboutDialog from "@/components/aboutDialog";

export default {
  name: 'app',
  components: {
    AboutDialog,
  },
  data() {
    return {
      showAbout:false
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang')
    if (this.$cookies.get('DICTA_USE_HEBREW') !== null) {
      this.$settings.hebrew = (this.$cookies.get('DICTA_USE_HEBREW') === 'true')
    } else if (lang !== null) {
      this.$settings.hebrew = lang.includes('he')
    } else {
      this.$settings.hebrew = true
    }
    if (this.$settings.hebrew) {
      document.body.classList.add('he')
    } else {
      document.body.classList.remove('he')
    }          
  },
  methods: {
    resetData () {
      this.$store.commit('RESET')
      if (this.$route.name !== 'Search')      
        this.$router.push({ name: "Search" })
    },
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }
  }  
}
</script>

<style lang="scss">
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
  font-style: normal;
  font-weight: bold;
}

a{
  cursor: pointer;    
}
.f-narkis{
  font-family: Roboto, mft_narkisclassic, sans-serif;
  line-height: 1.5;
}
.rounded-top {
  border-top-right-radius: 4px!important;
  border-top-left-radius: 4px!important;
}
.rounded-bottom {
  border-bottom-right-radius: 4px!important;
  border-bottom-left-radius: 4px!important;
} 
.centered {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dicta-dropdown .dropdown-item{text-align: left;}
.he .dicta-dropdown .dropdown-item{text-align: right;}  

.modal-footer{
  direction: ltr;
}

</style>

<style lang="scss" scoped>
.second-header {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
  direction: ltr;
  height:50px;
  color: white;
  justify-content: space-between;
  align-items: center;
  a{
    color:white;
    text-decoration:none;
    &:hover{
      text-decoration: none;
    }
  }  
  .btn-outline-light{
    margin-top:2px;
  }
}
.he .second-header{
  direction: rtl;
}
.logo-div {
  display: flex;
  align-items: center;
}
.logo {
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right : 15px;
  background:white;
  border-radius:50%;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.he .logo{
  margin-right:0;
  margin-left:15px;
}
.main-content {
  flex: auto;
  min-height: 500px;
}
@media only screen and (max-width: 767px) {
  html, body, #app {height: 100%;overflow:hidden}    
  .mobile-msg {    
    left: 0;
    top: 0;
    z-index: 999999999;
    height:100%;
    width:100%;
    img {
      max-width: 150px;
      height: auto;
    }
  }
}
</style>